import React from "react";
import {Sidebar} from './Sidebar';
import "../css/Site.css";
import { IndustryReports } from "./IndustryReports";

export class ReportContainer extends React.Component {
   render() {
        return (
            <div id="container">
                <div id="sidebar">
                    <Sidebar />
                </div>
                <div id="content">
                    <IndustryReports />
                </div>
            </div>
        );
    }
}